// extracted by mini-css-extract-plugin
module.exports = {"highlighted-cell":"HighlightedCell_highlighted-cell__3w4MH"};